import moduleCommon from './ko/modules/common';
export const enumMessages = {
    ko: {
        components: {
            modules: {
                common: moduleCommon,
            },
        },
    },
};
